export var groupBy = function (key) { return function (array) {
    return array.reduce(function (objectsByKeyValue, obj) {
        var value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});
}; };
// export const filterByValue = (array: any[], value: string) => {
//     return array.filter(o =>
//         Object.keys(o).some(k => {
//             if (k === 'masterColor') {
//                 return false;
//             }
//             if (typeof o[k] === 'string' && o[k].toLowerCase().includes(value.toLowerCase())) {
//                 return true
//             }
//             if (typeof o[k] === 'number' && o[k].toString().includes(value)) {
//                 return true
//             }
//             return false;
//         }));
// }
export var filterByValue = function (array, value, includes) {
    return array.filter(function (o) {
        return Object.keys(o).some(function (k) {
            if (includes && includes.length && includes.indexOf(k) === -1)
                return false;
            if (typeof o[k] === 'string' && o[k].toLowerCase().includes(value.toLowerCase())) {
                return true;
            }
            if (typeof o[k] === 'number' && o[k].toString().includes(Math.abs(+value))) {
                return true;
            }
            return false;
        });
    });
};
export var sortObjectByPropertyName = function (o) {
    var sorted = {}, key, a = [];
    for (key in o) {
        if (o.hasOwnProperty(key)) {
            a.push(key);
        }
    }
    a.sort();
    for (key = 0; key < a.length; key++) {
        sorted[a[key]] = o[a[key]];
    }
    return sorted;
};
//# sourceMappingURL=UtilHelper.js.map